import { IRootState } from '../../../store'
import { ISituationState } from '../store/ccHpi.types'

export const getSituationSelector = (state: IRootState): ISituationState => state.situation
